const determineGameStatus = (status, gameDetails) => {
    if (status === 'Forfeit by Away') return 'Final'
    if (status === 'Forfeit by Home') return 'Final'
    if (status === 'Forfeit by both teams') return 'Final'
    if (status === 'Forfeited') return 'Final'

    if (status === 'Pre-Game') return 'Pre-Game'
    if (gameDetails?.quarter === 0) return 'Pre-Game'
    if (gameDetails?.inning === 0) return 'Pre-Game'
    if (gameDetails?.period === 0 && status !== 'Final') return 'Pre-Game'
    if (status === 'Cancelled') return 'Pre-Game'
    if (status === 'Postponed') return 'Pre-Game'

    if (status === 'In-Progress') return 'In-Progress'
    if (gameDetails?.quarter > 0 && status !== 'Final') return 'In-Progress'
    if (gameDetails?.inning > 0 && status !== 'Final') return 'In-Progress'
    if (gameDetails?.period > 0 && status !== 'Final') return 'In-Progress'

    if (status === 'Suspended') return 'In-Progress'
    if (status === 'Delayed') return 'In-Progress'

    return 'Final'
}

export function leagueHelper(initObj, league, data) {
    const status = data?.details?.status
    const gameDetails = data?.details
    const modifiedStatus = determineGameStatus(status, gameDetails, league)
    const secondaryStatus = status === modifiedStatus ? null : status

    return {
        ...initObj,
        secondaryStatus: secondaryStatus,
        status: modifiedStatus,
    }
}
